import React from 'react';
export const MentionIconRendererContext = React.createContext(undefined);
//# sourceMappingURL=MentionIconRendererContext.js.map